<template>
  <div class="resource-recycling">
    <div
      class="header"
      id="mainHeader"
      :class="{ 'header-transparent': isHomePage }"
    >
      <div class="zuzhiguanxi">
        <p>天府再生资源云平台</p>
      </div>
      <div class="banner">
        <div
          v-for="item in bannerList"
          :key="item.value"
          class="banner-item"
          @click="clickBanner(item)"
          :class="{ checkedBanner: choseBannerStatus(item, checkedBanner) }"
        >
          <el-popover
            placement="bottom"
            width="130"
            popper-class="resource_popover"
            :disabled="!item.children"
            trigger="hover"
          >
            <div>
              <p
                class="childMenus"
                v-for="temp in item.children"
                :key="temp.path"
                :class="{ choseChildMenus: routerPath === temp.path }"
                @click.stop="$router.push(temp.path)"
              >
                {{ temp.name }}
              </p>
            </div>
            <p slot="reference">{{ item.name }}</p>
          </el-popover>
          <!-- 只在 "关于我们" 按钮上添加 Tooltip -->
          <!-- <el-tooltip
            v-if="item.name === '关于我们'"
            placement="bottom"
            effect="light"
            popper-class="contact-tooltip"
            :visible-arrow="true"
          >
            <template #content>
              <div @click.stop="copyContact" style="cursor: pointer">
                联系我们：{{ contact }}
              </div>
            </template>
            <div
              style="
                position: absolute;
                width: 100%;
                height: 100%;
                top: 0;
                left: 0;
              "
            ></div>
          </el-tooltip> -->
        </div>
        <!-- 新增搜索按钮 -->
        <div
          class="search-btn-container"
          v-if="$store.state.ordinaryLoggedIn"
          @click="handleSearch"
        >
          <i class="el-icon-search"></i>
        </div>
        <!--         <boardIndex /> -->
      </div>
      <div class="header-operate">
        <template v-if="!$store.state.ordinaryLoggedIn">
          <span @click="loginDialog" class="login userLogin btn">用户登录</span>
          <span @click="registerUser" class="register btn">注 册</span>
        </template>
        <template v-else>
          <span
            v-if="userInfo && userInfo.userDetail.userType == 3"
            @click="goToSupervision"
            class="regulatory-login btn"
            >政务登录</span
          >
          <el-dropdown placement="bottom-end">
            <span class="el-dropdown-link">
              <el-avatar
                title="用户中心"
                class="userStyle"
                icon="el-icon-user"
              ></el-avatar>
            </span>
            <el-dropdown-menu slot="dropdown">
              <div class="dropStyle">
                <div style="font-size: 14px">
                  {{ userInfo.userDetail.username }}
                </div>
                <div class="imgStyle">
                  <img
                    v-if="getTimeState"
                    src="@/assets/recycling/index/vip.png"
                    alt=""
                  />
                  <img
                    v-if="userInfo.userDetail.memberStatus == 0"
                    src="@/assets/recycling/index/hvip.png"
                    alt=""
                  />
                </div>
              </div>
              <!-- 绩效上报 -->
              <el-dropdown-item command="a" v-show="isShowPerformanceReport">
                <span
                  @click="priceReport('/performance')"
                  class="register logout btn"
                  >绩效上报</span
                >
              </el-dropdown-item>
              <!-- 价格上报 -->
              <el-dropdown-item command="a" v-show="isShowPriceReport">
                <span
                  @click="priceReport('/watePrice/priceReport')"
                  class="register logout btn"
                  >价格上报</span
                >
              </el-dropdown-item>
              <!-- 价格上报 -->
              <el-dropdown-item command="a" v-show="isShowPriceReport">
                <span
                  @click="priceReport('/qualificationApplication')"
                  class="register logout btn"
                  >资格申报</span
                >
              </el-dropdown-item>
              <!-- 价格上报 -->
              <el-dropdown-item command="a" v-show="isShowPriceReport">
                <span
                  @click="priceReport('/subsidyApplication')"
                  class="register logout btn"
                  >补贴申报</span
                >
              </el-dropdown-item>
              <!-- 退出登录 -->
              <el-dropdown-item command="a">
                <span @click="logout" class="register logout btn"
                  >退出登录</span
                >
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <!-- 新增消息通知模块 -->
          <el-popover
            placement="bottom"
            width="300"
            trigger="hover"
            popper-class="message-popover"
          >
            <template #reference>
              <div class="message-icon" @click.stop>
                <el-badge
                  :hidden="!unreadCount > 0"
                  :value="unreadCount"
                  :max="99"
                  class="item"
                >
                  <i class="el-icon-bell"></i>
                </el-badge>
              </div>
            </template>
            <div class="message-preview">
              <div class="message-header">
                <span>消息通知</span>
                <el-button type="text" @click="showAllMessages"
                  >查看全部
                </el-button>
              </div>
              <div class="message-list">
                <div
                  v-for="(item, index) in previewMessages"
                  :key="index"
                  class="message-item unread"
                  @click="handleMessageClick(item)"
                >
                  <div class="message-title">
                    <span class="message-title-name">{{ item.title }}</span>
                    <i
                      v-if="item.readstatus == 0"
                      style="color: orangered"
                      class="el-icon-message"
                    ></i>
                  </div>
                  <div class="message-time">{{ item.gmtCreated }}</div>
                </div>
                <div v-if="previewMessages.length === 0" class="empty-message">
                  暂无新消息
                </div>
              </div>
            </div>
          </el-popover>
          <div class="menu">
            <i class="el-icon-menu" @click="drawer = true"></i>
          </div>
        </template>
      </div>
    </div>
    <div
      class="scroll scroll-watch"
      :class="{ 'scroll-transparent': isHomePage }"
    >
      <!--      <component ref="childComponent" :is="currentComponent"></component>-->
      <router-view />
    </div>
    <div class="customer-service">
      <div class="service-content" @click="skipBtn">
        <img src="@/assets/recycling/index/fixed1.png" alt="天府码上收" />
        <p>码上收</p>
      </div>
      <el-tooltip
        placement="top"
        effect="light"
        popper-class="qr-code-tooltip"
        content="联系我们：028-83388891"
      >
        <div class="service-content" @click="showCustomerServiceDialog">
          <img src="@/assets/recycling/index/fixed2.png" alt="客服" />
          <p>客服</p>
        </div>
      </el-tooltip>
      <el-tooltip
        placement="top"
        effect="light"
        popper-class="qr-code-tooltip"
        content=""
      >
        <template #content>
          <img
            src="@/assets/recycling/index/qr-code.jpg"
            alt="客服二维码"
            style="width: 120px; height: 120px"
          />
        </template>

        <!-- <div class="service-content">
          <img
            src="@/assets/recycling/index/fixed3.png"
            alt="小程序"
            style="width: 36px; height: 36px"
          />
          <p>小程序</p>
        </div> -->
      </el-tooltip>
    </div>
    <home-login />
    <register-dialog
      :visible.sync="registerVisible"
      :show-captcha="false"
      @register-success="handleRegisterSuccess"
      @to-login="toLogin"
    />
    <customer-service-dialog
      :cstomerDialogVisible.sync="cstomerDialogVisible"
    />
    <message-center
      :visible.sync="messageDialogVisible"
      @updateMsgStatus="getMessageList"
    />
    <el-drawer :visible.sync="drawer" :with-header="false" size="35%">
      <el-menu :default-active="activeIndex" class="el-menu-vertical-demo">
        <template v-for="(item, inx) in bannerList">
          <el-menu-item
            v-if="!item.children"
            @click="goRouter(item.path)"
            :index="inx"
            :disabled="item.disabled"
          >
            {{ item.name }}
          </el-menu-item>
          <el-submenu v-if="item.children">
            <template slot="title">{{ item.name }}</template>
            <el-menu-item
              v-for="child in item.children"
              :index="child.path"
              @click="goRouter(child.path)"
            >
              {{ child.name }}
            </el-menu-item>
          </el-submenu>
        </template>
      </el-menu>
    </el-drawer>
  </div>
</template>

<script>
import { logoutPlatform } from '@/API/login/login';
import home from '@/views/home/home.vue';
import oneClickRecycle from '@/views/oneClickRecycle/index.vue';
import policyInformation from '@/views/policyInformation/index.vue';
import boardIndex from '@/components/boardIndex/boardIndex.vue';
import industrialEcology from '@/views/IndustrialEcology/index.vue';
import priceIndex from '@/views/PriceIndex/index.vue';
import addedServices from '@/views/addedServices/index.vue';
import government from '@/views/government/index.vue';
import homeLogin from '@/views/homeLogin/index.vue';
import { loginPlatform } from '@/API/login/login';
import { scrollTop } from '@/util/scrollTop';
import RegisterDialog from '@/components/registerUser/RegisterDialog.vue';
import CustomerServiceDialog from '@/views/others/customerService.vue';
import messageCenter from '@/components/messageCenter/messageCenter.vue';
import { getUserMessage, updateUserMessage } from '@/API/home/home';
import DC from '@/util/SocketHandler';
import router from '@/router';

export default {
  name: 'index',
  components: {
    home,
    oneClickRecycle,
    policyInformation,
    boardIndex,
    industrialEcology,
    priceIndex,
    addedServices,
    government,
    homeLogin,
    RegisterDialog,
    CustomerServiceDialog,
    messageCenter,
  },
  data() {
    return {
      value: [],
      registerVisible: false,
      currentComponent: 'home',
      routerPath: localStorage.getItem('routerPath') || '',
      drawer: false,
      activeIndex: 0,
      bannerList: [
        {
          name: '首页',
          path: '/Home/pages',
        },
        {
          name: '产业地图',
          path: '/recyclingOutlets',
          disabled: true,
        },
        {
          name: '天府码上收',
          path: '/Home/oneClickRecycle',
        },
        {
          name: '价格指数',
          path: '/Home/priceIndex',
        },
        {
          name: '政策资讯',
          path: '/Home/policyInformation',
        },
        {
          name: '政务服务',
          path: '/Home/government/homePage',
        },
        {
          name: '增值服务',
          path: '/Home/addedServices',
        },
        {
          name: '企业名录',
          path: '/Home/industrialEcology',
        },
        {
          name: '供需信息',
          path: '/Home/supplyDemand',
          children: [
            {
              name: '供应大厅',
              path: '/Home/supplyDemand/supplyHall',
            },
            {
              name: '求购大厅',
              path: '/Home/supplyDemand/purchaseHall',
            },
          ],
        },
        {
          name: '关于我们',
          path: '/Home/aboutUs',
          children: [
            {
              name: '公司简介',
              path: '/Home/aboutUs/companyProfile',
            },
            {
              name: '协会简介',
              path: '/Home/aboutUs/associationProfile',
            },
          ],
        },
      ],
      checkedBanner: localStorage.getItem('routerPath')
        ? localStorage.getItem('routerPath')
        : '/Home/pages',
      shangwuting: require('@/assets/recycling/index/商务厅.png'),
      hezuoshe: require('@/assets/recycling/index/CO-GP.png'),
      weiyuanhui: require('@/assets/recycling/index/weiyuanhui.png'),
      contact: '028-83388891',
      cstomerDialogVisible: false, // 客户服务弹窗
      userInfo: localStorage.getItem('ordinaryUser')
        ? JSON.parse(localStorage.getItem('ordinaryUser'))
        : null,
      // 新增消息相关数据
      allMessages: [],
      messageDialogVisible: false,
      unreadCount: 0,
      messageHandler: null, // 存储处理器
      isShowPriceReport: false, // 是否显示价格上报按钮
      isShowPerformanceReport: false,
      isHomePage: false, // 新增：是否首页状态
    };
  },
  computed: {
    getTimeState() {
      if (this.userInfo.userDetail.memberStatus == 1) {
        if (
          this.userInfo.userDetail.memberStartTime &&
          this.userInfo.userDetail.memberEndTime
        ) {
          let nowDate = new Date().getTime();
          let startTime = new Date(
            this.userInfo.userDetail.memberStartTime,
          ).getTime();
          let endTime = new Date(
            this.userInfo.userDetail.memberEndTime,
          ).getTime();
          return nowDate >= startTime && nowDate <= endTime;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    // 新增消息相关computed
    previewMessages() {
      return this.allMessages.slice(0, 5);
    },
  },
  watch: {
    $route(to, from) {
      this.checkedBanner = to.path.match(/^(\/[^/]+\/[^/]+)/)[0];
      this.routerPath = to.path;
      console.log(this.checkedBanner, this.routerPath, '对比路由差异');
      this.$store.commit('updateRouterClickStatus', this.checkedBanner);
      this.checkHomePageRoute(to.path);
    },
    '$store.state.login.menus': {
      handler: function (news, olds) {
        if (news) {
          let menuList = [];
          const filterMenus = function (data) {
            data.forEach((item) => {
              // 过滤树当中的无用数据
              if (item.name !== '主页') {
                menuList.push({
                  name: item.name,
                  path: item.path,
                  disabled: item.name == '产业地图' ? true : false,
                });
              }
              if (item.children && item.children.length) {
                filterMenus(item.children);
              }
            });
          };
          filterMenus(news);
          let filterResult = news.some((item) => {
            return item.name == '产业地图';
          });
          // 添加默认所有用户都可以访问，不受管控的路由
          menuList.splice(0, 0, {
            name: '首页',
            path: '/Home/pages',
          });
          if (filterResult) {
            menuList.splice(2, 0, {
              name: '天府码上收',
              path: '/Home/oneClickRecycle',
            });
          } else {
            menuList.splice(1, 0, {
              name: '天府码上收',
              path: '/Home/oneClickRecycle',
            });
          }

          let objMenu = [
            // {
            //   path: '/mapscp',
            //   name: '全国地理数据',
            // },
            {
              name: '供需信息',
              path: '/Home/supplyDemand',
              children: [
                {
                  name: '供应大厅',
                  path: '/Home/supplyDemand/supplyHall',
                },
                {
                  name: '求购大厅',
                  path: '/Home/supplyDemand/purchaseHall',
                },
              ],
            },
            {
              name: '关于我们',
              path: '/Home/aboutUs',
              children: [
                {
                  name: '公司简介',
                  path: '/Home/aboutUs/companyProfile',
                },
                {
                  name: '协会简介',
                  path: '/Home/aboutUs/associationProfile',
                },
              ],
            },
          ];
          menuList = [...menuList, ...objMenu];
          this.bannerList = menuList;
          // 查询用户未登录前访问的路由是否在登陆后的权限管控中
          let result = menuList.some((user) => {
            // 首先检查当前项是否有匹配
            if (user.path == this.checkedBanner) {
              return true;
            }
            // 如果当前项有children，则递归检查children
            if (user.children && user.children.length) {
              return user.children.some((child) => {
                return child.path == this.checkedBanner;
              });
            }
            return false;
          });
          if (!result) {
            setTimeout(() => {
              this.$router.push('/Home/pages');
            }, 100);
          }
        }
      },
    },
  },
  created() {
    let userInfo = localStorage.getItem('ordinaryUser');
    let userDetail = JSON.parse(userInfo)?.userDetail;
    if (userDetail && userDetail.userType && userDetail.userType == 2) {
      this.isShowPriceReport = true;
    } else if (userDetail && userDetail.userType && userDetail.userType == 1 && userDetail.bindCompany) {
      this.isShowPerformanceReport = true;
    } else {
      this.isShowPriceReport = false;
      this.isShowPerformanceReport = false;
    }
    console.log('userinfo', userDetail);
  },
  mounted() {
    const container = document.getElementsByClassName('scroll-watch');
    if (container[0]) {
      container[0].addEventListener('scroll', this.handleScroll);
    }
    // 新增：初始检查当前路由
    this.checkHomePageRoute(this.$route.path);
    this.getMessageList();
    this.registerMessage();
  },
  beforeDestroy() {
    const container = document.getElementsByClassName('scroll-watch');
    if (container[0]) {
      container[0].removeEventListener('scroll', this.handleScroll);
    }
  },
  methods: {
    goRouter(path) {
      this.$router.push(path);
      // window.scrollTo(0, 0);
      this.drawer = false;
    },
    handleScroll() {
      const container = document.getElementsByClassName('scroll-watch')[0];
      if (!this.isHomePage) return;
      this.scrollPosition = container.scrollTop;
      // 根据透明度添加/移除scrolled类
      const header = document.getElementById('mainHeader');
      if (this.scrollPosition > 200) {
        header.classList.remove('header-transparent');
        container.classList.remove('scroll-transparent');
      } else {
        header.classList.add('header-transparent');
        container.classList.add('scroll-transparent');
      }
    },
    // 新增：检查是否为首页路由的方法
    checkHomePageRoute(path) {
      this.isHomePage = path.includes('/Home/pages');
    },
    registerMessage() {
      // 保存处理器引用
      this.messageHandler = (data) => {
        this.getMessageList();
      };
      DC.registerMessageHandler(
        'MESSAGE',
        'messageNotify',
        this.messageHandler,
      );
    },
    unregisterMessage() {
      if (this.messageHandler) {
        DC.unregisterMessageHandler(
          'MESSAGE',
          'messageNotify',
          this.messageHandler,
        );
        this.messageHandler = null; // 清理引用
      }
    },
    getMessageList() {
      let parmrs = {
        pageNum: '1',
        pageSize: '10',
      };
      getUserMessage(parmrs).then((res) => {
        if (res.code === 200) {
          this.allMessages = res.data?.records || [];
          this.unreadCount = res.data.unreadNum;
        }
      });
    },
    skipBtn() {
      this.$router.push('/Home/oneClickRecycle');
      this.activeIndex = 2;
      this.$store.commit('updateRouterClickStatus', '/Home/oneClickRecycle');
      scrollTop();
    },
    copyContact() {
      navigator.clipboard
        .writeText(this.contact)
        .then(() => {
          this.$message.success('联系方式已复制');
        })
        .catch(() => {
          this.$message.error('复制失败，请手动选择');
        });
    },
    clickBanner(Router) {
      if (Router.children && Router.children.length) return false;
      if (!Router.path) {
        return false;
      }
      this.$router.push(Router.path);
      scrollTop();
    },
    scrollTop() {
      this.$refs.childComponent.moveHome();
    },
    // 退出清空缓存信息
    clearMessage() {
      this.$store.commit('changeOrdinaryUser', '');
      this.$store.commit('SET_OrdinaryLoggedIn', false);
      localStorage.removeItem('ordinaryToken');
      localStorage.removeItem('ordinaryUser');
      localStorage.removeItem('ordinaryLoggedIn');
    },
    logout() {
      logoutPlatform().then((res) => {
        if (res.code === 200) {
          this.$message.success('退出登录成功！');
          this.$router.push('/Home/pages');
          window.location.reload();
          let banner = [
            {
              name: '产业地图',
              path: '/recyclingOutlets',
            },
            {
              name: '价格指数',
              path: '/Home/priceIndex',
            },
            {
              name: '政策信息',
              path: '/Home/policyInformation',
            },
            {
              name: '政务服务',
              path: '/Home/government/homePage',
            },
            {
              name: '增值服务',
              path: '/Home/addedServices',
            },
            {
              name: '企业名录',
              path: '/Home/industrialEcology',
            },
          ];
          this.$store.commit('login/changeMenus', banner);
          this.clearMessage();
        }
      });
    },
    // 登录操作
    loginDialog() {
      this.$store.commit('login/changeLoginDialogVisible', true);
    },
    // 注册用户
    registerUser() {
      this.registerVisible = true;
    },
    handleRegisterSuccess(userInfo) {
      // 处理注册成功逻辑
      console.log('注册成功', userInfo);
    },
    toLogin() {
      // 跳转到登录
      this.registerVisible = false;
      // 这里可以打开登录弹窗或跳转登录页面
      this.loginDialog();
    },
    // 监管登录
    goToSupervision() {
      this.$router.push('/supervisionHomepage/Punishment');
    },
    // 客户服务
    showCustomerServiceDialog() {
      if (this.$store.state.ordinaryUser) {
        this.cstomerDialogVisible = true;
      } else {
        this.$confirm('用户未登录，是否前往登录', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          customClass: 'confStyle',
        })
          .then(() => {
            this.$store.commit('login/changeLoginDialogVisible', true);
          })
          .catch(() => {});
      }
    },
    handleMessageClick(message) {
      // 这里可以添加点击消息后的处理逻辑，比如跳转到详情页
      // 关闭所有通知
      this.$notify.closeAll();
      // 弹出新通知
      this.$notify.warning({
        title: message.title,
        message: message.content,
        customClass: 'top-center-notify', // 关键：自定义 class
        duration: 5000,
      });
      if (message.readstatus === 0) {
        updateUserMessage(message.id).then((res) => {
          if (res.code === 200) {
            message.readstatus = 1;
            this.unreadCount--;
          }
        });
      }
    },
    showAllMessages() {
      // 添加日志确认方法被调用
      console.log('showAllMessages called');
      this.messageDialogVisible = true;
      // 确保数据是最新的
      this.$nextTick(() => {
        console.log('Dialog visibility:', this.messageDialogVisible);
      });
    },
    // 价格上报
    priceReport(url) {
      this.$router.push(url);
    },
    // 新增搜索处理方法
    handleSearch() {
      // 这里可以添加跳转搜索页或弹出搜索框的逻辑
      console.log('点击搜索');
      // 示例：跳转到搜索页面，如果有的话
      this.$router.push('/search');
    },
    // 确认banner选中状态
    choseBannerStatus(Router, path) {
      let status = false;
      if (Router.children && Router.children.length) {
        status = Router.children.some((item) => {
          return item.path.includes(path);
        });
      } else {
        status = Router.path.includes(path);
      }
      return status;
    },
  },
  destroyed() {
    this.unregisterMessage(); // 销毁时清理
  },
};
</script>

<style scoped lang="less">
/* 自定义 Tooltip 样式 */
.contact-tooltip {
  padding: 8px 12px;
  font-size: 14px;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

  &:hover {
    background: #f5f7fa;
  }
}

/* 确保 banner-item 有相对定位 */
.banner-item {
  position: relative;
}

.childMenus {
  height: 40px;
  width: inherit;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  cursor: pointer;
  border-radius: 0px 0px 0px 0px;
  margin-bottom: 10px;
}

.childMenus:last-child {
  margin-bottom: 0px;
}

.childMenus:hover {
  background: rgba(21, 173, 97, 0.1);
  color: #15ad61;
  border-radius: 0px 0px 0px 0px;
}

.choseChildMenus {
  background: rgba(21, 173, 97, 0.1);
  color: #15ad61;
  border-radius: 0px 0px 0px 0px;
}

.resource-recycling {
  background: #fafafaff;
  height: 100vh;
  padding: 0 !important;
  /deep/ .el-dialog {
    //width: 25%;
    border-radius: 5px;
    .el-dialog__header .el-dialog__title {
      color: #333;
    }

    // 表单最大盒子
    .el-form {
      padding: 0 32px;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      color: #fff;
    }

    // 按钮
    .loginBTN {
      z-index: 1;
      width: 100%;
      font-size: 18px;
      position: relative;
      overflow: hidden;
      transition: color 0.4s ease-in-out;
    }

    .loginBTN::before {
      content: '';
      z-index: -1;
      position: absolute;
      top: 50%;
      left: 50%;
      width: 2em;
      height: 2em;
      border-radius: 50%;
      transform-origin: center;
      transform: translate3d(-50%, -50%, 0) scale3d(0, 0, 0);
      transition: transform 0.45s ease-in-out;
    }

    .loginBTN:hover::before {
      transform: translate3d(-50%, -50%, 0) scale3d(15, 15, 15);
    }

    /deep/ .el-form-item {
      margin: 0;
    }

    // 输入框背景色
    /deep/ .el-input__inner {
      background: transparent;
      color: #fff;
      height: 0 !important;
      padding: 19px 10px 19px 28px;
      background-clip: content-box;

      &::first-line {
        color: #fff;
      }
    }

    // 输入框初始颜色
    /deep/ .el-input__inner:-webkit-autofill {
      -webkit-text-fill-color: #fff;
    }

    // 提示字
    /deep/ .el-input__inner {
      &::placeholder {
        color: #999;
        font-size: 16px;
      }
    }

    // 粒子背景
    .login-bg {
      width: 100%;
      height: 100%;
    }
  }
}

/* 新增透明头部样式 */
.header-transparent {
  position: absolute;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0) !important;
  transition: background-color 0.3s ease; /* 添加过渡效果 */
  z-index: 100;
  // .banner-item:hover {
  //   background: #009E54 !important;
  //   color: #fff !important;
  // }
  // .banner-item {
  //   color: #333333 !important;
  // }
  // .checkedBanner {
  //   background: #009E54 !important;
  //   color: #fff !important;
  // }
  &:hover {
    background-color: #ffffff !important;
  }
}

.header {
  width: 100%;
  height: 86px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  background-color: #ffffff;

  .zuzhiguanxi {
    display: flex;
    height: 50px;
    align-items: center;

    p {
      font-size: 24px;
      min-width: 287px;
      font-weight: 700;
      width: inherit;
      text-align: center;
      letter-spacing: 1px;
      line-height: 34.75px;
      color: #000000;
    }
  }

  .system-name {
    font-size: 24px;
    font-weight: 700;
    letter-spacing: 1px;
    display: flex;
    justify-content: center;
    color: rgba(0, 0, 0, 1);
  }

  .banner {
    display: flex;
    flex: 8;
    align-items: center;
    box-sizing: border-box;
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 1px;
    color: rgba(51, 51, 51, 0.9);
    height: 50px;
    opacity: 1;
    background: rgba(0, 0, 0, 0);
    padding-left: 10px;

    .banner-item {
      margin-right: 8px;
      padding: 5px 20px;
      font-size: 20px;
      font-weight: 400;
      letter-spacing: 1px;
      line-height: 20.27px;
      color: #333333;
      cursor: pointer;

      p {
        height: 30px;
        line-height: 30px;
      }
    }

    .banner-item:hover {
      color: #fff;
      background: #009e54;
      border-radius: 50px;
    }

    .checkedBanner {
      color: #fff;
      font-weight: 700;
      background: #009e54;
      border-radius: 50px;
    }
    // 新增搜索按钮样式
    .search-btn-container {
      margin-left: auto; /* 推到右侧 */
      padding: 5px 15px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;

      i {
        font-size: 20px;
        color: #333333;
        transition: color 0.3s;
      }

      &:hover i {
        color: #009e54;
      }
    }
  }

  .header-operate {
    display: flex;
    flex: 1;
    justify-content: right;
    padding-right: 10px;
    align-items: center;
    // padding-left: 50px;
    span:last-child {
      cursor: pointer;
    }

    .login-btn,
    .regulatory-login {
      cursor: pointer;
      display: inline-block;
      width: 120px;
      height: 28px;
      opacity: 1;
      border-radius: 50px;
      background: #43cf7c;
      line-height: 28px;
      font-size: 14px;
      font-weight: 400;
      letter-spacing: 1px;
      color: rgba(225, 225, 225, 1);
      text-align: center;
      margin: 0 16px;
    }

    .userLogin {
      background-color: #ffffff;
      color: black;
      cursor: pointer;
    }

    .register {
      display: inline-block;
      width: 80px;
      height: 28px;
      opacity: 1;
      border-radius: 50px;
      background: rgba(67, 207, 124, 1);
      //line-height: 28px;
      font-size: 14px;
      font-weight: 400;
      letter-spacing: 1px;
      color: rgb(255, 255, 255);
      text-align: center;
      margin-left: 16px;
      cursor: pointer;
    }

    .logout {
      background: rgb(239, 70, 70);
    }

    .btn {
      width: 105px;
      height: 39px;
      opacity: 1;
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(67, 207, 124, 1);
      color: rgb(255, 255, 255);
      font-size: 18px;
      &:hover {
        background-color: #ebebeb;
        color: #000000;
      }
    }
  }
}

.scroll-transparent {
  height: 100% !important;
}

.scroll {
  height: calc(100% - 85px);
  overflow-y: scroll;
}

.customer-service {
  position: fixed;
  bottom: 100px;
  right: 24px;
  padding: 10px 8px;
  border-radius: 10px;
  text-align: center;
  cursor: pointer;
  z-index: 10;

  .service-content {
    width: 80px;
    height: 80px;
    opacity: 1;
    // border-radius: 60px;
    background: #1abe6b;
    padding-top: 15px;
    box-sizing: border-box;
    margin-bottom: 22px;

    img {
      margin: 0 auto;
      width: 40px;
      height: 40px;
    }

    p {
      font-size: 14px;
      font-weight: 700;
      letter-spacing: 0px;
      color: rgba(255, 255, 255, 1);
    }

    .el-icon-s-custom {
      font-size: 24px;
    }

    // &:hover {
    //   background-color: #2D56B5;
    // }
  }

  & > i {
    font-size: 32px;
    color: rgb(94, 196, 196);
  }

  & > p {
    font-size: 16px;
  }

  // &:hover {
  //   background-color: #b1adad62;
  //   i {
  //     color: rgb(10, 209, 209);
  //   }
  // }
}

.userStyle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  cursor: pointer;
  color: #606266;
  border-radius: 50%;
  background-color: #43cf7c;

  /deep/ .el-icon-user {
    color: #ffffff;
    font-size: 18px;
  }
}

.dropStyle {
  text-align: center;
  border-bottom: 1px solid #dcdfe6;
}

.imgStyle {
  display: flex;
  justify-content: center;
  img {
    width: 60px;
    height: 30px;
  }
}

/* 新增消息通知样式 */
.message-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  margin-right: 15px;
  cursor: pointer;
  color: #606266;
  border-radius: 50%;
  background-color: #43cf7c;
  margin-left: 15px;

  &:hover {
    color: #409eff;
  }

  .el-icon-bell {
    font-size: 18px;
    color: #ffffff;
  }
}

.menu {
  display: none;
}

.message-preview {
  padding: 10px;

  .message-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 10px;
    border-bottom: 1px solid #ebeef5;
    margin-bottom: 10px;

    span {
      font-weight: bold;
    }
  }

  .message-list {
    max-height: 300px;
    overflow-y: auto;

    .message-item {
      padding: 8px 0;
      border-bottom: 1px solid #f5f5f5;
      cursor: pointer;

      &:hover {
        background-color: #f5f7fa;
      }

      &.unread {
        .message-title {
          font-weight: bold;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .message-title-name {
            max-width: 160px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }

      .message-title {
        margin-bottom: 4px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .message-time {
        font-size: 12px;
        color: #909399;
        max-width: 250px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .empty-message {
      text-align: center;
      padding: 20px;
      color: #909399;
    }
  }
}

.pagination-container {
  margin-top: 20px;
  text-align: center;
}

.unread-text {
  font-weight: bold;
  color: #303133;
}

/* 消息弹窗样式 */
:deep(.message-popover) {
  padding: 0 !important;
}

/* 原有样式保持不变，新增以下媒体查询 */
@media screen and (max-width: 768px) {
  /* 头部适配：垂直排列 + 缩小尺寸 */
  .header {
    display: flex;
    height: auto;
    padding: 5px 5px 5px 5px;

    .zuzhiguanxi {
      p {
        font-size: 14px !important;
        min-width: auto;
      }
    }

    .banner {
      display: none;
    }

    .header-operate {
      padding-right: 0;

      .btn {
        width: 70px !important;
        height: 30px !important;
        //padding: 5px 10px;
        font-size: 14px !important;
      }
    }
  }

  .userStyle {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    cursor: pointer;
    color: #606266;
    border-radius: 50%;
    background-color: #43cf7c;

    /deep/ .el-icon-user {
      font-size: 18px !important;
    }
  }

  .message-icon {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    width: 30px !important;
    height: 30px !important;
    .el-badge {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .el-icon-bell {
      font-size: 18px !important;
      margin: 0;
    }
  }

  .menu {
    display: block;
    .el-icon-menu {
      font-size: 32px;
    }
  }
  .service-content {
    width: 40px !important;
    height: 40px !important;
    img {
      width: 20px !important;
      height: 20px !important;
    }
    p {
      font-size: 10px !important;
      font-weight: unset !important;
    }
  }
  .confStyle {
    width: 90% !important;
  }
}
:deep(.el-dropdown-menu__item) {
  display: flex;
  justify-content: center;
  text-align: center;
}
</style>
<style>
/* 强制让通知框居中 */
.top-center-notify {
  left: 50% !important;
  transform: translateX(-50%) !important;
  top: 85px !important; /* 调整距离顶部的位置 */
}

.resource_popover {
  padding: 10px 0 !important;
}
</style>
